var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C2.44772 5 2 5.44772 2 6V15C2 15.5523 2.44772 16 3 16H17C17.5523 16 18 15.5523 18 15V6C18 5.44771 17.5523 5 17 5H3ZM16.8241 6L3.17591 6L3.31311 6.1102L8.92358 10.6166L8.92361 10.6167C9.23482 10.8667 9.61331 11 10 11C10.3867 11 10.7652 10.8667 11.0764 10.6167L11.0764 10.6166L16.6869 6.1102L16.8241 6ZM3 7.14134V15H17V7.14134L11.7027 11.3963L11.7026 11.3963C11.2171 11.7863 10.6185 12 10 12C9.38144 12 8.78289 11.7863 8.29733 11.3963L3 7.14134Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailI);
export default __webpack_public_path__ + "static/media/Email-i.954779db4b6bdcaf70cd84aa5c2be8f9.svg";
export { ForwardRef as ReactComponent };